import { useState, useEffect }  from 'react';
import api                      from '../../services/api.js';    
import FarolForm                from './FarolForm';
import { useFarol }             from '../../contexts/FarolPageContext';
import { toSelectOptions }      from '../../utils/reactUtils';

export function FarolFormContainer() {
       
    const { 
    
        handleFarolModalClose, 
        handleUpdateFarolCards, 
        isFarolModalOpen, 
        
        selectedFarolTerminal,
        setSelectedFarolTerminal,

        setSelectedFarol,
        selectedFarol
    
    } = useFarol()


    const [ _farolData,       _setFarolData    ] = useState(null);
    const [ _isEditMode,      _setIsEditMode   ] = useState(false);
    const [ _formData,        _setFormData     ] = useState({});
    
    const [ _restrictions,        _setRestrictions      ] = useState([]);
    const [ _hoopers,             _setHoopers           ] = useState([]);
    const [ _terminals,           _setTerminals         ] = useState([]);
    const [ _products,            _setProducts          ] = useState([]);
    const [ _clients,             _setClients           ] = useState([]);
    const [ _categories,          _setCategories        ] = useState([]);

    const _handleCloseForm = async () => {
        
        setSelectedFarolTerminal(null)
        setSelectedFarol(null)
        handleFarolModalClose()
        handleUpdateFarolCards()
        _setHoopers([])
    }

    const _handleCreateSubmit = async (farolData) => {
        const response = await api.post(`/createFarol/${selectedFarolTerminal}`, { farolData })
        if (response.status === 201) _handleCloseForm()
    }

    const _handleUpdateSubmit = async (farolData) => {
        const response = await api.put(`/updateFarol/${selectedFarol}`, { farolData })
        if (response.status === 201) _handleCloseForm() 
    }

    const _handleSubmit = async (formData) => {

        const { description, category, farolRestriction, hooper, client, product } = formData;

        const completeFormData = { description, categoryId: category?.value, farolRestrictionId: farolRestriction?.value, hooperId: hooper?.value, clientId: client?.value, productId: product?.value };
  
        _isEditMode ? _handleUpdateSubmit(completeFormData) : _handleCreateSubmit(completeFormData)

    }

    const _handleDelete = async () => {
        
        try{
            
            const response = await api.delete(`/deleteFarol/${selectedFarol}`)

            if (response.status === 204) _handleCloseForm()

        }catch(error){

            console.log(error)

        }
    }

    const _fetchFormData = async () => {
        
        try{

            const response = await api.get(`/getFarolFormData/${selectedFarolTerminal}`)
            
            if (response.data.length === 0) return

            const { restriction, terminals, products, clients, categories, hoopers } = response.data

            _setRestrictions(toSelectOptions(restriction))
            _setTerminals(toSelectOptions(terminals))
            _setProducts(toSelectOptions(products))
            _setClients(toSelectOptions(clients))
            _setCategories(toSelectOptions(categories))
            _setHoopers(toSelectOptions(hoopers))

        }catch(error){

            console.log(error)
        }
    }

    const _fetchEditFormData = async () => {
    
        
        try{

            const response = await api.get(`/getFarolData/${selectedFarol}`)
            
            const { farolData } = response.data

            _setFarolData(farolData)

        }catch(error){

            console.log(error)
        }

    }

    const _setupEditMode = async () => {
        await Promise.all([ _fetchFormData(), _fetchEditFormData()])
        _setIsEditMode(true)
    }

    const _setupCreateMode = async () => {
        await _fetchFormData();
        _setFarolData(null);
        _setIsEditMode(false);
    }
    
    useEffect(() => {
        
        if (!isFarolModalOpen) return;

        selectedFarol ? _setupEditMode() : _setupCreateMode();
     
    }, [isFarolModalOpen, selectedFarol, selectedFarolTerminal]);

    return (

        <FarolForm 

            isOpen={isFarolModalOpen} 
            onClose={_handleCloseForm} 

            onSubmit={_handleSubmit} 
            
            isEditMode={_isEditMode} 
            formEditValues={_farolData}
            handleDelete={_handleDelete}

            optionsRestrictions={_restrictions}
            optionsTerminals={_terminals}
            optionsProducts={_products}
            optionsClients={_clients}
            optionsCategories={_categories}
            optionsHoopers={_hoopers}

        />

    )

}


export default FarolFormContainer;
